"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.GridContainerGutter = {
    xs: '0.75rem',
    s: '1.5rem',
    m: '2rem',
    l: '2rem',
    xl: '2.75rem'
};
exports.GridItemGutter = {
    xs: '0.25rem',
    s: '0.5rem',
    m: '0.5rem',
    l: '0.5rem',
    xl: '0.75rem'
};
exports.GridTotalColumns = 12;
var printWidthCss = function (size) {
    var str = '';
    for (var i = 1; i <= exports.GridTotalColumns; i += 1) {
        str += "&.nds-" + size + "-" + i + " {width: calc(100% * " + i + " / " + exports.GridTotalColumns + ");}";
    }
    return "" + str;
};
var GridContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 ", ";\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  &._ndsGridCont--compact {\n    padding: 0 !important;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 ", ";\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n  }\n\n  &._ndsGridCont--compact {\n    padding: 0 !important;\n  }\n"])), exports.GridContainerGutter.xs, function (props) { return props.theme.SizeBreakpointsS; }, exports.GridContainerGutter.s, function (props) { return props.theme.SizeBreakpointsM; }, exports.GridContainerGutter.m, function (props) { return props.theme.SizeBreakpointsXl; }, exports.GridContainerGutter.xl);
var GridItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 ", ";\n\n  ", "\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n    ", "\n  }\n"], ["\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 ", ";\n\n  ", "\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    ", "\n  }\n\n  @media (min-width: ", ") {\n    padding: 0 ", ";\n    ", "\n  }\n"])), exports.GridItemGutter.xs, printWidthCss('xs'), function (props) { return props.theme.SizeBreakpointsS; }, exports.GridItemGutter.s, printWidthCss('s'), function (props) { return props.theme.SizeBreakpointsM; }, printWidthCss('m'), function (props) { return props.theme.SizeBreakpointsL; }, printWidthCss('l'), function (props) { return props.theme.SizeBreakpointsXl; }, exports.GridItemGutter.xl, printWidthCss('xl'));
var Grid = function (props) {
    var _a, _b, _c, _d, _e;
    var container = props.container, children = props.children, xs = props.xs, s = props.s, m = props.m, l = props.l, xl = props.xl, classNameProp = props.className, compact = props.compact, other = __rest(props, ["container", "children", "xs", "s", "m", "l", "xl", "className", "compact"]);
    if (container !== undefined) {
        var classNames = clsx_1.default(classNameProp, {
            '_ndsGridCont--compact': compact
        });
        return react_1.default.createElement(GridContainer, { className: classNames }, children);
    }
    return (react_1.default.createElement(GridItem, __assign({ className: clsx_1.default(classNameProp, (_a = {}, _a["nds-xs-" + xs] = xs !== undefined, _a), (_b = {}, _b["nds-s-" + s] = s !== undefined, _b), (_c = {}, _c["nds-m-" + m] = m !== undefined, _c), (_d = {}, _d["nds-l-" + l] = l !== undefined, _d), (_e = {}, _e["nds-xl-" + xl] = xl !== undefined, _e)) }, other), children));
};
Grid.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]),
    container: prop_types_1.default.bool,
    item: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    xs: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    s: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    m: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    l: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    xl: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
    compact: prop_types_1.default.bool
};
Grid.defaultProps = {
    children: null,
    container: undefined,
    item: true,
    className: null,
    xs: undefined,
    s: undefined,
    m: undefined,
    l: undefined,
    xl: undefined,
    compact: false
};
exports.default = Grid;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Grid.js.map